module.exports = __webpack_public_path__ + "img/elroi.3a0564b8.png";